var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor tavily-web-search" }, [
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Arama Sorgusu"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Arama sorgusu girin",
            "show-attributes": true,
            "show-emoji": false,
          },
          model: {
            value: _vm.clone.query,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "query", $$v)
            },
            expression: "clone.query",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Arama Derinliği"),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            model: {
              value: _vm.clone.search_depth,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "search_depth", $$v)
              },
              expression: "clone.search_depth",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "basic" } }, [
              _vm._v("Temel"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "advanced" } }, [
              _vm._v("Gelişmiş"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Ham İçeriği Dahil Et"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_raw_content,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_raw_content", $$v)
            },
            expression: "clone.include_raw_content",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Görselleri Dahil Et"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_images,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_images", $$v)
            },
            expression: "clone.include_images",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Görsel Açıklamalarını Dahil Et"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_image_descriptions,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_image_descriptions", $$v)
            },
            expression: "clone.include_image_descriptions",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Cevabı Dahil Et"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_answer,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_answer", $$v)
            },
            expression: "clone.include_answer",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Dahil Edilecek Alan Adları"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.clone.include_domains, function (domain, index) {
          return _c(
            "div",
            { key: "domain-" + index, staticClass: "key-value-pair" },
            [
              _c("a-input", {
                staticClass: "domain-input",
                attrs: { placeholder: "Alan adı (örn: example.com)" },
                model: {
                  value: _vm.clone.include_domains[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.include_domains, index, $$v)
                  },
                  expression: "clone.include_domains[index]",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "link", danger: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeDomain(index)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("delete"),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "a-button",
          {
            staticClass: "add-btn",
            attrs: { type: "dashed", block: "" },
            on: { click: _vm.addDomain },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(" Alan Adı Ekle\n        "),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Maksimum Sonuç Sayısı"),
        ]),
        _vm._v(" "),
        _c("a-input-number", {
          attrs: { min: 1, max: 10 },
          model: {
            value: _vm.clone.max_results,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "max_results", $$v)
            },
            expression: "clone.max_results",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }